// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"ir-z","giftOrPromoSelector":"jr-z","disabled":"kr-z","subTitle":"lr-z","selectShipAddressMessage":"mr-z","changePayment":"nr-z"};